import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { Kno2DirectorySearchComponent } from './directory-search-kno2.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { Kno2SearchModule } from 'src/app/shared/kno2-search/kno2-search.module';
import { BreadcrumbModule } from 'src/app/shared/breadcrumb/breadcrumb.module';


@NgModule({
  imports: [
    CommonModule,
    DialogsModule,
    PopupModule,
    TranslateModule,
    InputsModule,
    ReactiveFormsModule,
    LayoutModule,
    ButtonModule,
    ButtonsModule,
    DropDownsModule,
    GridModule,
    BreadcrumbModule,
    Kno2SearchModule
  ],
  declarations: [
    Kno2DirectorySearchComponent,
  ],
  exports: [
    Kno2DirectorySearchComponent
  ]
})
export class Kno2DirectorySearchModule { }
